import React, { useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { IUniqueSwapperCount } from '../../api/interfaces'
import { IChart } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'

async function getUniqueSwapCountConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_unique_swapper_count', timeframe)) as IUniqueSwapperCount[]
	let series1: {
		x: number
		y: number
	}[] = []

	if (timeframe === '1d') {
		series1 = chartData.map((element: IUniqueSwapperCount) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.DAILY_UNIQUE_SWAPPER_COUNT }
		})
	} else if (timeframe === '1w') {
		series1 = chartData.map((element: IUniqueSwapperCount) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.WEEKLY_UNIQUE_SWAPPER_COUNT }
		})
	} else if (timeframe === '1m') {
		series1 = chartData.map((element: IUniqueSwapperCount) => {
			return { x: new Date(element.DAY).getTime() / 1000, y: element.MONTHLY_UNIQUE_SWAPPER_COUNT }
		})
	}
	const config: IChart[] = [
		{
			data: series1,
			strokeWidth: 2,
			name: 'unique swap count',
			type: 'bars',
			seriesGroup: '[swapper #]',
			color: 'green'
		}
	]
	return { config: config, latestValue: series1[series1.length - 1].y, latestValueDate: series1[series1.length - 1].x }
}

const UniqueSwapCount = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getUniqueSwapCountConfig)

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="Unique Swapper Count"
			chartDesc="Daily count of unique addresses that executed at least one swap. Measures the breadth of active users rather than just transaction volume."
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="9f40c912-a4f3-4377-9419-0bd1d62b8ccd"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
		/>
	)
}

export default UniqueSwapCount
